// extracted by mini-css-extract-plugin
module.exports = {"menuTrigger":"menutrigger_menuTrigger__SfPBk","icon":"menutrigger_icon__1ke7H","collapsed":"menutrigger_collapsed__1KHfj"};